<script setup lang="ts">
import { ref, computed, watch } from 'vue'

import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectGroup,
  SelectLabel,
  SelectItem,
} from "@/components/ui/select"

import { get_data_attr } from '@/utils/globals'
import { useViewStore } from '@/stores/viewStore'

type SelectItemType = {
  value: string | number
  label: string
}

const props = defineProps<{
  items?: SelectItemType[]
}>()

const emit = defineEmits<{
  (e: "change", value: string | number): void
}>()

const viewStore = useViewStore()

const items = computed(() => {
  const baseItems = props.items ?? get_data_attr("standorts")
  return props.items && props.items.length > 0
    ? [{ value: -1, label: "Global" }, ...baseItems]
    : baseItems
})
const isGlobalStandortSelect = computed(() => !props.items)
const selected = ref<string | number | null>(
  isGlobalStandortSelect.value ? viewStore.currentStandort : null
)

watch(selected, (newVal, oldVal) => {
  if (newVal === null || newVal === oldVal) return

  if (isGlobalStandortSelect.value) {
    viewStore.setCurrentStandort(newVal)
    window.location.href = `?session_id=-1&standort_id=${newVal}`
    return
  }

  emit("change", newVal)
})
</script>

<template>
  <div class="hoeppner-bg-white h-10">
    <Select v-model="selected">
      <SelectTrigger>
        <SelectValue placeholder="Standort..." />
      </SelectTrigger>

      <SelectContent class="z-[10002]">
        <SelectGroup>
          <SelectLabel>Standort Selektion</SelectLabel>

          <SelectItem
            v-for="item in items"
            :key="item.value"
            :value="item.value"
          >
            {{ item.label }}
          </SelectItem>

        </SelectGroup>
      </SelectContent>
    </Select>
  </div>
</template>